import { render, staticRenderFns } from "./GeneralJournalImport.vue?vue&type=template&id=04762236"
import script from "./GeneralJournalImport.vue?vue&type=script&lang=js"
export * from "./GeneralJournalImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports